import styles from './EventCard.module.scss';
import type { EventCardProps } from './interfaces';
import ButtonLink from '../ButtonLink/ButtonLink';
import { ClickableAction } from '../Clickable/consts';
import clsx from 'clsx';
import { ButtonAlign } from '../Button/consts';

const EventCard = ({ date, headline, text, buttonText }: EventCardProps) => {
  return (
    <div className={styles.base}>
      <div className={styles.date}>{date}</div>
      <div className={clsx(styles.headline, styles.singleLineClamp)}>
        {headline}
      </div>
      <hr />
      <div className={clsx(styles.text, styles.doubleLineClamp)}>{text}</div>
      <div className={styles.moreButton}>
        <ButtonLink
          noClickable={true}
          actionType={ClickableAction.None}
          align={ButtonAlign.Center}
        >
          {buttonText}
        </ButtonLink>
      </div>
    </div>
  );
};

export default EventCard;
